import React, { useEffect, useState } from 'react';

interface StandbyPageProps {
  onStart: () => void;
}

const StandbyPage: React.FC<StandbyPageProps> = ({ onStart }) => {
  const [fontLoaded, setFontLoaded] = useState(false);
  
  useEffect(() => {
    // Check if font is already loaded
    if (document.fonts.check('1em "Material Symbols Outlined"')) {
      setFontLoaded(true);
    } else {
      document.fonts.ready.then(() => {
        setFontLoaded(true);
      });
    }
  }, []);

  const handleStart = () => {
    // WebView2環境（C#アプリ内）で実行されているかチェック
    if ((window as any).chrome?.webview) {
      // C#側にメッセージを送信
      (window as any).chrome.webview.postMessage('start_recording');
    } else {
      // 通常のブラウザで開かれた場合の処理
      console.warn('WebView2環境ではありません');
      onStart();
    }
  };

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans JP", sans-serif',
        background: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          padding: '40px',
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          maxWidth: '500px',
          width: '90%',
        }}
      >
        <div
          style={{
            fontSize: '80px',
            color: '#667eea',
            marginBottom: '20px',
          }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: '80px', width: 'auto', height: 'auto', overflow: 'visible', opacity: fontLoaded ? 1 : 0, transition: 'opacity 0.2s ease' }}>
            smart_toy
          </span>
        </div>
        <h1
          style={{
            fontSize: '28px',
            fontWeight: 700,
            color: '#333',
            marginBottom: '16px',
          }}
        >
          AI Meeting Assistant
        </h1>
        <p
          style={{
            fontSize: '18px',
            color: '#666',
            marginBottom: '40px',
            lineHeight: 1.6,
          }}
        >
          開始ボタンをクリックしてください
        </p>
        <button
          onClick={handleStart}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '16px 32px',
            fontSize: '18px',
            fontWeight: 600,
            color: '#fff',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
          }}
        >
          <span className="material-symbols-outlined" style={{ width: '24px', height: '24px', overflow: 'hidden', opacity: fontLoaded ? 1 : 0 }}>play_arrow</span>
          開始
        </button>
        <p
          style={{
            marginTop: '30px',
            fontSize: '14px',
            color: '#999',
          }}
        >
          会議をAIがサポートします
        </p>
      </div>
    </div>
  );
};

export default StandbyPage;

